<template>
	<div>
		<div
			class="modal fade modal-fullscreen-mobile"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div class="modal-header modal-header-banner">
						<button
							class="button button-transparent button-modal-back"
							@click="close"
						>
							<i class="sk-icon-times"></i>
						</button>
						<div>
							<h1>Verify Your Phone Number</h1>
						</div>
						<div class="header-description">
							Your phone number is your login - it’s also how we
							alert you when your food is ready.
						</div>
						<img src="/images/2k-phone.png" alt="Phone" />
					</div>
					<div class="modal-body">
						<loading :active="loading" />
						<div class="modal-inner-content">
							<div class="phone-number-instructions">
								A 5 digit code has been sent to
								<b>{{ phone | phoneNumber }}</b>
							</div>
							<div class="code-container">
								<input
									:value="code | charAt(0)"
									@input="setCodeDigit($event, 0)"
									type="number"
									ref="digitInput0"
								/>
								<input
									:value="code | charAt(1)"
									@input="setCodeDigit($event, 1)"
									type="number"
									ref="digitInput1"
								/>
								<input
									:value="code | charAt(2)"
									@input="setCodeDigit($event, 2)"
									type="number"
									ref="digitInput2"
								/>
								<input
									:value="code | charAt(3)"
									@input="setCodeDigit($event, 3)"
									type="number"
									ref="digitInput3"
								/>
								<input
									:value="code | charAt(4)"
									@input="setCodeDigit($event, 4)"
									type="number"
									ref="digitInput4"
								/>
							</div>
							<button
								class="button button-primary"
								@click="validateVerificationCode"
							>
								Verify
							</button>
							<button
								class="button button-text"
								@click="resendCodeClicked"
							>
								Not Working?
								<b>Resend Code {{ phone | phoneNumber }}</b>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	justify-content: flex-start;
	background: var(--sk-grey-bg);
}

.modal-header {
	flex-direction: column;
}

.modal-header-banner {
	height: 100%;
	padding: 20px;
	justify-content: flex-start;
	max-height: 335px;
	min-height: 200px;
}

.modal-header-banner > div {
	margin: 0 auto;
	display: block;
}

.modal-header-banner h1,
.modal-header-banner .header-description {
	color: var(--gR-white);
}

.modal-header-banner h1 {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 12px;
}

.modal-header-banner img {
	margin: 48px auto;
	display: block;
	object-fit: contain;
	max-height: 140px;
	min-height: 40px;
	height: auto;
	width: auto;
}

.modal-header-banner .header-description {
	font-size: 12px;
}

.modal-inner-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
}

.modal-inner-content .button,
.modal-header-banner > div {
	max-width: 335px !important;
	width: 335px !important;
}

.code-container {
	height: 100%;
	max-height: 218px;
	flex-shrink: 1;
	align-items: center;
	display: flex;
}

.code-container input {
	width: 50px;
	height: 50px;
	background: var(--gR-white2);
	border: 0;
	outline: 0;
	border-radius: 5px;
	border: 1px solid var(--sk-inputGray);
	text-align: center;
	color: var(--sk-grey3);
	font-size: 24px;
}

.code-container input:not(:last-child) {
	margin-right: 20px;
}

.modal-inner-content .button {
	flex-shrink: 0;
}

.phone-number-instructions {
	font-size: 12px;
	color: var(--sk-grey2);
	margin-bottom: 5px;
}

.phone-number-instructions b {
	color: var(--sk-grey3);
	font-weight: 400;
}

@media only screen and (min-width: 500px) {
	.code-container {
		height: 218px;
	}
}

@media only screen and (max-height: 675px) {
	.modal-header-banner img {
		margin-bottom: 0;
		margin-top: 20px;
	}
}
</style>

<script>
import { eventBus, EventBusEvents } from "@/eventBus"
import { NotificationType } from "@/enums/NotificationType"
import phoneFilterMixin from "@/mixins/phone-filter-mixin"
import Loading from "vue-loading-overlay"

export default {
	name: "VerifyLoginModal",
	components: {
		Loading
	},
	mixins: [phoneFilterMixin],
	filters: {
		charAt: function (value, pos) {
			if (!value) {
				return value
			}
			return value[pos]
		}
	},
	data: function () {
		return {
			code: { 0: "", 1: "", 2: "", 3: "", 4: "" },
			focusing: false,
			loading: false,
			isOpen: false,
			phone: ""
		}
	},
	methods: {
		open(options) {
			this.isOpen = true
			this.loading = false
			this.code = { 0: "", 1: "", 2: "", 3: "", 4: "" }
			if (options && options.required) {
				$(this.$refs.modal).modal({
					backdrop: "static",
					keyboard: false
				})
			} else {
				$(this.$refs.modal).modal("show")
			}
			this.phone = options.phone
		},
		setCodeDigit(event, position) {
			event.preventDefault()
			event.stopPropagation()
			const regex = /[0-9]/
			let input =
				event.target.value.length > 0
					? event.target.value[event.target.value.length - 1]
					: ""
			event.target.value = input
			if (regex.test(input) && this.code[position] != undefined) {
				this.code[position] = input
				const refKey = `digitInput${position + 1}`
				const nextInput = this.$refs[refKey]
				if (nextInput) {
					nextInput.focus()
				} else {
					this.validateVerificationCode().catch(() => {
						this.code = { 0: "", 1: "", 2: "", 3: "", 4: "" }
						if (this.$refs["digitInput0"]) {
							this.$refs["digitInput0"].focus()
						}
					})
				}
			}
		},
		async validateVerificationCode() {
			try {
				const code = Object.entries(this.code)
					.sort((a, b) => Number(a[0]) - Number(b[0]))
					.map((entry) => entry[1])
					.join("")

				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Validation Code Entered",
					data: {
						code: code
					}
				})

				if (code.length == 5) {
					this.loading = true
					const isVerified = await this.$store.dispatch(
						"verifyUser",
						code
					)
					this.loading = false
					if (isVerified) {
						this.close("VERIFIED")
					} else {
						this.$store.dispatch("sendMixpanelEvent", {
							msg: "Validation Code Invalid",
							data: {
								code: code
							}
						})
						eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
							message: "Invalid code entered, please try again.",
							type: NotificationType.ERROR
						})
					}
				} else {
					this.bugsnag.notify("Validation Code Empty", (event) => {
						event.addMetadata("data", {
							code: code,
							codeHash: this.code
						})
					})
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "Validation Code Invalid",
						data: {
							code: code
						}
					})
					eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
						message: "Invalid code entered, please try again.",
						type: NotificationType.ERROR
					})
				}
			} catch (e) {
				this.loading = false
				eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
					message: e.message
						? "Something went wrong, please try again."
						: e,
					type: NotificationType.ERROR
				})
				throw e
			}
		},
		resendCodeClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Resend Validation Code Clicked"
			})
			this.close("RESEND")
		},
		close(result) {
			this.emitResult(result)
			$(this.$refs.modal).modal("hide")
		},
		emitResult(result) {
			if (this.isOpen) {
				this.$emit("onResult", result)
				this.isOpen = false
			}
		}
	},
	mounted: function () {
		$(this.$refs.modal).on("hidden.bs.modal", () => {
			this.emitResult(false)
		})
	}
}
</script>
